export default [
  'name',
  'address',
  'city',
  'state',
  'email',
  'phone',
  'status',
  { key: 'user', label: 'Owner', sorter: false },
  { key: 'action', label: '' }
]
